export enum OrganizationActionTypes {
	SET = "@@organization/SET",
	CLEAR = "@@organization/CLEAR",
	UPDATE = "@@organization/UPDATE",
}

export type OrganizationApplicationState = {
	slug: string;
	name: string;
	type: string;
};
export type OrganizationState = {
	id?: number;
	name?: string;
	permissions: string[];
	applications: OrganizationApplicationState[];
	company_id: string;
	currency?: string;
	license_expires_at?: string;
	license_type?: string;
	accept_privacy?: boolean;
	accept_terms?: boolean;
	accept_rules?: boolean;
	admin?: boolean;
	partner?: boolean;
	intercom_id?: string;
	intercom_company_id?: string;
	intercom_hash_web?: string;
	timezone?: string;
	languages?: string[];
};

export interface RemoveOrganizationApi {
	token: string;
	reason: string;
}

export enum OrganizationCategory {
	"CLUB" = "CLUB",
	"RESTAURANT" = "RESTAURANT",
	"CAFE" = "CAFE",
	"FOODTRUCK" = "FOODTRUCK",
	"PUB_BAR" = "PUB_BAR",
	"SUSHI" = "SUSHI",
	"SHOP" = "SHOP",
	"OTHERS" = "OTHERS",
}
